<script>
import ProfileLayout from "@/Layouts/ProfileLayout.vue";

export default {
    layout: ProfileLayout,
};
</script>

<script setup>
import { computed } from "vue";
import { Head, usePage } from "@inertiajs/vue3";
import FollowButton from "@/Components/Profile/FollowButton.vue";
import FriendsGrid from "@/Components/Profile/FriendsGrid.vue";
import ProfileHero from "@/Components/Profile/ProfileHero.vue";
import ProfileTabs from "@/Components/Profile/ProfileTabs.vue";

// Another user's profile view — visiting your own page redirects to the
// Friends area, so `owner` is always someone else here.
const inertiaPage = usePage();

const owner = computed(() => inertiaPage.props.owner.data);

const followers = computed(() => inertiaPage.props.followers?.data ?? []);

const ownerShortName = computed(() =>
    owner.value.is_organization
        ? owner.value.presentation_name
        : owner.value.first_name,
);

const title = computed(() => `${ownerShortName.value}’s Followers`);

const emptyMessage = computed(() =>
    owner.value.connections_hidden
        ? `${ownerShortName.value} keeps their followers private.`
        : `${ownerShortName.value} doesn’t have any followers yet.`,
);
</script>

<template>
    <div>
        <Head>
            <title>Followers | Gift Hero</title>
        </Head>

        <ProfileHero
            :owner="owner"
            :is-owner="false"
            :theme="owner.profile_theme"
        />

        <ProfileTabs :owner="owner" :is-owner="false" active="followers" />

        <div class="px-4 pb-8 sm:px-[35px] sm:pb-9">
            <FriendsGrid
                :people="followers"
                :title="title"
                :empty-message="emptyMessage"
            >
                <template #action>
                    <FollowButton :owner="owner" />
                </template>
            </FriendsGrid>
        </div>
    </div>
</template>
